import React from 'react';
import AssetTeamNavBar from '../../../../layouts/asset-team/AssetTeamNavBar';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import ActiveCustomersGraph from '../../../shared/customers/active-customers/ActiveCustomersGraph';

const AssetTeamActiveCustomers = () => {
  const { profile } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AssetTeamNavBar currentPage="Active Customer" position={firstName} />
        <div className="mt-5">
          <ActiveCustomersGraph />
        </div>
      </main>
    </div>
  );
};

export default AssetTeamActiveCustomers;
